import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../components/ui/select";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Services() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [f, setF] = useState({ name: "", category: "grooming", duration_min: 30, price: 0, gst_percent: 18, description: "" });

  const load = () => api.get("/services").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  useEffect(() => {
    setF(edit ? { name: edit.name, category: edit.category, duration_min: edit.duration_min, price: edit.price, gst_percent: edit.gst_percent, description: edit.description || "" }
      : { name: "", category: "grooming", duration_min: 30, price: 0, gst_percent: 18, description: "" });
  }, [edit, open]);

  const save = async () => {
    try {
      if (edit) await api.patch(`/services/${edit.id}`, f);
      else await api.post("/services", f);
      toast.success("Saved");
      setOpen(false); setEdit(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => { try { await api.delete(`/services/${id}`); load(); } catch { toast.error("Failed"); } };

  return (
    <div className="space-y-5" data-testid="services-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Catalog</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight mt-1">Services</h1>
        </div>
        <Button onClick={() => { setEdit(null); setOpen(true); }} data-testid="add-service-btn"><Plus className="w-4 h-4 mr-1" />New service</Button>
      </div>

      <Card className="p-4">
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Category</TableHead><TableHead>Duration</TableHead><TableHead className="text-right">Price</TableHead><TableHead>GST</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map(s => (
              <TableRow key={s.id}>
                <TableCell className="font-medium">{s.name}</TableCell>
                <TableCell className="text-xs uppercase tracking-widest text-muted-foreground">{s.category}</TableCell>
                <TableCell>{s.duration_min}m</TableCell>
                <TableCell className="text-right font-mono">₹{s.price}</TableCell>
                <TableCell>{s.gst_percent}%</TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="sm" onClick={() => { setEdit(s); setOpen(true); }}>Edit</Button>
                  <Button variant="ghost" size="sm" onClick={() => del(s.id)}><Trash2 className="w-4 h-4" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setEdit(null); }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>{edit ? "Edit" : "New"} service</DialogTitle></DialogHeader>
          <div className="space-y-2">
            <div><Label>Name *</Label><Input value={f.name} onChange={e => setF(p => ({ ...p, name: e.target.value }))} data-testid="svc-name" /></div>
            <div><Label>Category</Label>
              <Select value={f.category} onValueChange={v => setF(p => ({ ...p, category: v }))}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  {["grooming", "bath", "treatment", "boarding", "training", "vet", "other"].map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <div><Label>Duration (m)</Label><Input type="number" value={f.duration_min} onChange={e => setF(p => ({ ...p, duration_min: parseInt(e.target.value) || 0 }))} /></div>
              <div><Label>Price</Label><Input type="number" value={f.price} onChange={e => setF(p => ({ ...p, price: parseFloat(e.target.value) || 0 }))} data-testid="svc-price" /></div>
              <div><Label>GST %</Label><Input type="number" value={f.gst_percent} onChange={e => setF(p => ({ ...p, gst_percent: parseFloat(e.target.value) || 0 }))} /></div>
            </div>
            <div><Label>Description</Label><Input value={f.description} onChange={e => setF(p => ({ ...p, description: e.target.value }))} /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save} data-testid="save-service">Save</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
